import Img1 from "../../assets/images/ImageGallery/1.webp";
import Img2 from "../../assets/images/ImageGallery/2.webp";
import Img3 from "../../assets/images/ImageGallery/3.webp";
import Img4 from "../../assets/images/ImageGallery/4.webp";
import Img5 from "../../assets/images/ImageGallery/5.webp";
import Img6 from "../../assets/images/ImageGallery/6.webp";
import Img7 from "../../assets/images/ImageGallery/7.webp";
import Img8 from "../../assets/images/ImageGallery/8.webp";
import Img9 from "../../assets/images/ImageGallery/9.webp";
import Img10 from "../../assets/images/ImageGallery/10.webp";

export const IMAGE_DATA = [
  {
    id: 1,
    image: Img1,
  },
  {
    id: 2,
    image: Img2,
  },
  {
    id: 3,
    image: Img3,
  },
  {
    id: 4,
    image: Img4,
  },
  {
    id: 5,
    image: Img5,
  },
  {
    id: 6,
    image: Img6,
  },
  {
    id: 7,
    image: Img7,
  },
  {
    id: 8,
    image: Img8,
  },
  {
    id: 9,
    image: Img9,
  },
  {
    id: 10,
    image: Img10,
  },
];
